export const getPercentageChange = (valueOne, valueTwo) => {
  return 100 * ((valueTwo - valueOne) / valueOne);
};

export const percentageOf = (valueOne, valueTwo, decimals = 2) => {
  return parseFloat((valueOne * 100) / valueTwo).toFixed(decimals);
};
